import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-center"
      offset={80}
      mobileOffset={68}
      expand
      visibleToasts={4}
      closeButton
      // 2026-02-28 — force the toast container ABOVE every modal in the
      // app. PhotoManager (and other seller modals) live at z-[9998];
      // sonner's default is 999999 in newer builds but our older
      // version renders under app modals. Passing `style` puts the
      // z-index directly on `[data-sonner-toaster]` so toasts always
      // stack on top of open modals and can't get lost behind them.
      style={{ zIndex: 100000 }}
      toastOptions={{
        // Keep toasts narrow enough that they never span the full width of
        // the header row — critical on mobile so they never overlap the
        // Shop Now / Tour chips beneath the sticky top bar. `pointer-events-auto`
        // is preserved on the toast itself but the CONTAINER is set to
        // `pointer-events-none` in a global CSS override so clicks passing
        // through empty regions of the toaster still reach the UI.
        className: "!max-w-[min(94vw,380px)]",
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
